/**
 * debounces a function with the given period, optionally doing it on the
 * "front" edge (via immediate=true). Taken and tweaked from
 * https://davidwalsh.name/javascript-debounce-function where it was attributed
 * to UnderscoreJS.
 */
function debounce(func, wait, immediate = false) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export default debounce;



// WEBPACK FOOTER //
// ./src/util/debounce.js